import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { STATES, STATE_CENTERS, STATE_SHAPES } from "./constants";
/**
 * Returns US state center points as geojson features
 */

export var getStateCenters = function getStateCenters() {
  return STATE_CENTERS;
};
/**
 * Returns US state shapes as geojson features
 */

export var getStateShapes = function getStateShapes() {
  return STATE_SHAPES;
};
/**
 * Returns state data for the given fips
 * @param {*} fips
 */

export var getStateFromFips = function getStateFromFips(fips) {
  return STATES[fips];
};
/**
 * Gets the property for the given identifier.
 * @param {string} id identifier for any geography
 * @param {string} prop property name to get from the states object
 */

export var getStateProp = function getStateProp(id, prop) {
  if (typeof id !== "string") {
    throw new Error("state identifier must be string");
  }

  if (id.length > 2) {
    id = id.substring(0, 2);
  }

  return STATES[id] && STATES[id][prop] ? STATES[id][prop] : null;
};
/**
 * Get the state for this given fips code
 * @param {*} id fips code for the state
 */

export var getState = function getState(id) {
  return STATES[id];
};
/**
 * Returns states data as an array
 */

export var getStatesArray = function getStatesArray() {
  return Object.keys(STATES).map(function (state) {
    return _objectSpread({
      id: state
    }, STATES[state]);
  });
};
/**
 * Gets the state abbreviation for the provided identifier
 * @param {string} id identifier for any geography
 */

export var getStateAbbr = function getStateAbbr(id) {
  return getStateProp(id, "abbr");
};
export var getStateAbbrFromName = function getStateAbbrFromName(name) {
  var stateKey = Object.keys(STATES).find(function (fips) {
    return STATES[fips].full.toLowerCase() === name.toLowerCase();
  });
  return stateKey ? STATES[stateKey].abbr.toLowerCase() : "us";
};
/**
 * Gets the state name for the provided identifier
 * @param {string} id identifier for any geography
 */

export var getStateName = function getStateName(id) {
  return getStateProp(id, "full");
};
/**
 * Returns the full state name for the state abbreviation
 * @param {*} abbr
 */

export var getStateNameFromAbbr = function getStateNameFromAbbr(abbr) {
  var fips = getStateFipsFromAbbr(abbr);
  return STATES[fips].full;
};
/**
 * Gets a list of state options for `<Select />`
 */

export var getStateSelectOptions = function getStateSelectOptions() {
  return Object.keys(STATES).map(function (fips) {
    return {
      id: STATES[fips]["abbr"].toLowerCase(),
      label: STATES[fips]["full"]
    };
  }).sort(function (a, b) {
    return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
  });
};
/**
 * Gets the state FIPS code from abbreviation
 * @param {*} abbr
 */

export var getStateFipsFromAbbr = function getStateFipsFromAbbr(abbr) {
  if (!abbr || abbr === "us") {
    return null;
  }

  return Object.keys(STATES).find(function (fips) {
    return STATES[fips].abbr.toUpperCase() === abbr.toUpperCase();
  });
};
/**
 * Get a property from the static states object from the abbreviation
 * @param {*} abbr (2 letter code)
 * @param {*} prop (prop to get)
 */

export var getStatePropByAbbr = function getStatePropByAbbr(abbr, prop) {
  var stateFips = getStateFipsFromAbbr(abbr);
  return stateFips ? getStateProp(stateFips, prop) : null;
};
/**
 * Returns array of all states
 */

export var getAllStates = function getAllStates() {
  return Object.keys(STATES).map(function (k) {
    return _objectSpread({
      id: k
    }, STATES[k]);
  }).sort(function (a, b) {
    return a.full.toUpperCase() > b.full.toUpperCase() ? 1 : -1;
  });
};